import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useMachineryDirectiveEhsrClauseList } from '@/shared/hooks/api/machineryDirectiveCompliance'
import type { EhsrClause, MachineryDirectiveEhsrTranslations } from './types'

const EHSR_NAMESPACE = 'machineryDirectiveEhsr'

/** EHSR picker options localized to the signed-in user's UI language. */
export function useMachineryDirectiveEhsrList(): EhsrClause[] {
  const { i18n, t } = useTranslation(EHSR_NAMESPACE)
  const { data: ehsrClausesMeta = [] } = useMachineryDirectiveEhsrClauseList()

  return useMemo(() => {
    const localized = t('clauses', {
      returnObjects: true,
      defaultValue: {},
    }) as MachineryDirectiveEhsrTranslations['clauses']

    return ehsrClausesMeta.map((meta) => {
      const entry = localized[meta.id]
      return {
        ...meta,
        label: entry?.label ?? meta.id,
        selectedLabel: entry?.selectedLabel ?? meta.id,
        sectionLabels: entry?.sectionLabels,
      }
    })
  }, [ehsrClausesMeta, i18n.language, t])
}
